module.exports = __webpack_public_path__ + "img/logo-j.0be113d4.svg";